import { Injectable, SecurityContext } from '@angular/core';
import { ViewEnum } from '../../app.constants';
import { NavbarMessageEvent } from '../model/navbar-message.event';
import { Program } from '../program/model/program';
import { LOCK_STUDY_NOT_OWNED_PERMISSIONS } from '../auth/permissions';
import { Principal } from '../auth/principal.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class UrlService {
    private static readonly ALLOWED_PROTOCOLS: ReadonlyArray<string> = ['http:', 'https:'];

    constructor(private principal: Principal,
                private sanitizer: DomSanitizer,
                private router: Router
    ) {
    }

    createStudy() {
        window.top.postMessage({ toolSelectedUrl: ViewEnum.CREATE_STUDY }, '*');
        return false;
    }

    isStudyNotUserAccessible(studyId: any, studyName: any, isLocked: boolean, ownerId: any, user: any) {
        return (isLocked && user && !user.userRoles.some((userRole) => userRole.role.name === 'SuperAdmin') && user.id !== ownerId
            && !this.principal.hasAnyAuthorityDirect(LOCK_STUDY_NOT_OWNED_PERMISSIONS));
    }

    openStudy(studyId: any, studyName: string, program: Program = null) {
        let message: NavbarMessageEvent;
        if (program) {
            message = {
                programSelected: program,
                toolSelectedUrl: ViewEnum.STUDY_EDITOR,
                toolSelectedName: 'Study: ' + studyName,
                viewData: {
                    studyId: studyId
                }
            };
        }

        window.top.postMessage(message, '*');
        return false;
    }

    openList(listId: number, listName: string, program: Program = null) {
        let message: NavbarMessageEvent;
        if (program) {
            message = {
                programSelected: program,
                toolSelectedUrl: ViewEnum.GERMPLASM_LIST_MANAGER,
                toolSelectedName: 'List: ' + listName,
                viewData: {
                    listId: listId,
                    listName: listName
                }
            };
        }
        window.top.postMessage(message, '*');
        return false;
    }


    /**
     * Validates a user-supplied URL against an allowlist of protocols and hosts.
     * Returns the normalized URL string if it is safe, or null otherwise.
     */
    buildSafeUrl(rawUrl: string | null): string | null {
        if (!rawUrl) {
            return null;
        }
        const sanitized = this.sanitizer.sanitize(SecurityContext.URL, rawUrl);
        let parsed: URL;
        try {
            // Use window.location.origin as a base so that relative URLs are resolved
            // against the current origin (which is inherently safe).
            parsed = new URL(sanitized, window.location.origin);
        } catch {
            return null;
        }

        if (!UrlService.ALLOWED_PROTOCOLS.includes(parsed.protocol)) {
            return null;
        }

        const isSameOrigin = parsed.origin === window.location.origin;
        if (!isSameOrigin) {
            return null;
        }

        return parsed.toString();
    }
}
